import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Preloader from 'components/Preloader';
import { ping } from 'actions/app';
import { isAssessmentAdminUser, isConsultantUser, isSuperadminUser } from 'helpers/postAuthRedirect';
import { isAuthenticated } from 'helpers/authToken';
import { getLocalizedPath } from 'helpers/getLocale';

// /dashboard renders no content of its own — it is a thin role-resolver.
// It checks auth, asks the backend who the user is (`ping` → roles), then
// redirects to the gamified user profile or the counselor dashboard.
const DashboardResolver = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(() => {
    let cancelled = false;

    (async () => {
      if (!isAuthenticated()) {
        navigate(getLocalizedPath('/sign-in'), { replace: true });
        return;
      }
      let user = null;
      try {
        const res = await dispatch(ping());
        user = res?.user || null;
      } catch (_) {
        // Non-fatal — default to the user dashboard.
      }
      if (cancelled) return;
      navigate(
        getLocalizedPath(isSuperadminUser(user)
          ? '/dashboard/admin'
          : isAssessmentAdminUser(user) ? '/dashboard/assessments'
          : isConsultantUser(user) ? '/dashboard/counselor' : '/dashboard/user'),
        { replace: true }
      );
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate, dispatch]);

  return <Preloader />;
};

export default DashboardResolver;
